// Copyright (C) AirWorks Solutions, Inc - All Rights Reserved
// DO NOT REDISTRIBUTE
// UNAUTHORIZED COPYING OF THIS FILE, ANY PART OR WHOLE, VIA ANY MEDIUM IS STRICTLY PROHIBITED
// PROPRIETARY AND CONFIDENTIAL

// This function returns the status text corresponding to an orderStatus
/* eslint-disable import/prefer-default-export */
export const GetOrderStatus = (status: number) =>
  (status === 0 && 'Created') ||
  (status === 1 && 'Processing') ||
  (status === 2 && 'Autonomous successful') ||
  (status === 3 && 'Autonomous failed') ||
  (status === 4 && 'Manual drafting') ||
  (status === 5 && 'US QC') ||
  (status === 6 && 'Ready to Upload') ||
  (status === 7 && 'Done') ||
  (status === 8 && 'Canceled');

export type CustomerOrderStatus = 'Sourcing data' | 'Processing' | 'Completed' | 'Canceled' | 'Estimate';

// Customer-facing status words — the vocabulary the project sidebar badge has always used, shared with
// Order History now that in-flight orders list there (AUT-6526). GetOrderStatus above is the admin
// dropdown's internal vocabulary and stays off customer surfaces. Returns null when the order carries
// no state to name (an unplaced non-estimate, or a row from a server that sends no orderStatus) —
// callers render a dash, never a guessed state.
export const getCustomerOrderStatus = ({
  orderStatus,
  kmlOnly,
  isEstimate,
}: Pick<IOrder, 'orderStatus' | 'kmlOnly' | 'isEstimate'>): CustomerOrderStatus | null => {
  if (orderStatus === 7) return 'Completed';
  if (orderStatus === 8) return 'Canceled';
  // KML-only order placed but its pipeline is deferred until data is sourced (AUT-6266): "Sourcing data",
  // not the generic "Processing" — the clock hasn't started. Once an admin relaunches, orderStatus advances
  // past 1 and it reads "Processing" like any order.
  if (kmlOnly && orderStatus === 1) return 'Sourcing data';
  if (orderStatus !== undefined && orderStatus > 0 && orderStatus < 7) return 'Processing';
  if (isEstimate) return 'Estimate';
  return null;
};
